module.exports = __webpack_public_path__ + "img/promozione.d339d5d4.svg";